import { createFormData } from 'src/helpers';
import { IMenuSetResponseBody } from 'src/api/getMenuSet';
import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { ICreateMenuSetRequest } from './types';

export const createMenuSet = async (payload: ICreateMenuSetRequest): Promise<IMenuSetResponseBody> => {
  const res = await fetch(`${API_URL}/menus/menu-sets`, {
    method: 'POST',
    body: createFormData(payload),
  });

  if (!res.ok) {
    let errorBody: { message?: string } | null;
    try {
      errorBody = await res.json();
    } catch {
      errorBody = null;
    }
    throw new Error(errorBody?.message || res.statusText);
  }

  return res.json();
};
